function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { useSortBy } from 'react-instantsearch';
import { FormikWrapper } from '@uncinc/uncinc-react-kitchen-sink';
import { DEFAULT_TEXT } from '../../config/constants';
import SortByRadios from './Radios';
import SortBySelect from './Select';
const FormElement = props => {
  const {
    inputType,
    placeholder,
    ...restProps
  } = props;
  switch (inputType) {
    case 'radios':
      {
        return /*#__PURE__*/React.createElement(SortByRadios, _extends({}, restProps, {
          title: placeholder
        }));
      }
    case 'select':
    default:
      {
        return /*#__PURE__*/React.createElement(SortBySelect, _extends({}, restProps, {
          placeholder: placeholder
        }));
      }
  }
};
const SearchSortBy = props => {
  const {
    t
  } = useTranslation();
  const {
    placeholder = t(['searchkit.sort_by.placeholder', DEFAULT_TEXT.SORT_BY.PLACEHOLDER]),
    className,
    itemClassName,
    inputType = 'select',
    ...restProps
  } = props;
  const {
    options,
    currentRefinement,
    refine
  } = useSortBy(props);
  const classNames = c('Searchkit__SortBy', className);
  const itemClassNames = c('Searchkit__SortBy__item', itemClassName);
  return /*#__PURE__*/React.createElement(FormikWrapper, {
    initialValues: {
      sortBy: currentRefinement
    },
    enableReinitialize: true
  }, /*#__PURE__*/React.createElement(FormElement, _extends({}, restProps, {
    inputType: inputType,
    options: options,
    defaultValue: currentRefinement,
    placeholder: placeholder,
    className: itemClassNames,
    wrapperClassName: classNames,
    onChange: value => {
      refine(value);
    }
  })));
};
export default SearchSortBy;